import {Component, OnInit, Input} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {PlumberDetails} from '../../data-objects/plumber-details';

const numberRE = /^[0-9]*$/;

@Component({
  selector: 'app-plumber-details',
  templateUrl: './plumber-details.component.html',
  styleUrls: ['./plumber-details.component.css']
})
export class PlumberDetailsComponent implements OnInit {

  @Input()
  plumberDetails: PlumberDetails;
  @Input()
  isReadOnly: boolean;
  @Input()
  drainerNameLabel: string;
  @Input()
  drinkingWaterPlumberNameLabel = 'Drinking water Plumber';
  @Input()
  showBelowGroundPlumbingLabel: boolean;
  @Input()
  showDrinkingWaterPlumbingLabel = true;
  @Input()
  isPlumberCompanyAllowed: boolean;
  @Input()
  isRecycledSelected: boolean;
  @Input()
  isRecycledWaterZone: boolean;
  @Input()
  isBelowGroundPlumbingSelected: boolean;
  @Input()
  isDrinkingWaterSelected: boolean;
  @Input()
  isDrinkingWaterMandatory = true;
  @Input()
  isBelowGroundPlumbingMandatory = true;
  @Input()
  isRecycledWaterMandatory = true;

  drainerNameControl: FormControl;
  drainerPhoneNumberControl: FormControl;
  drainerLicenseNumberControl: FormControl;
  drinkingWaterPlumberNameControl: FormControl;
  drinkingWaterPlumberCompanyControl: FormControl;
  drinkingWaterPlumberPhoneNumberControl: FormControl;
  drinkingWaterPlumberLicenseNumberControl: FormControl;
  recycledWaterPlumberNameControl: FormControl;
  recycledWaterPlumberLicenseNumberControl: FormControl;
  recycledWaterPlumberPhoneNumberControl: FormControl;

  drainerNameControlMaxLength = 50;
  drainerPhoneNumberControlMaxLength = 10;
  drainerPhoneNumberControlMinLength = 10;
  drainerLicenseNumberMaxLength = 6;
  drinkingWaterPlumberNameControlMaxLength = 50;
  drinkingWaterPlumberCompanyControlMaxLength = 200;
  drinkingWaterPlumberPhoneNumberControlMaxLength = 10;
  drinkingWaterPlumberPhoneNumberControlMinLength = 10;
  drinkingWaterPlumberLicenseNumberControlMaxLength = 6;
  recycledWaterPlumberNameControlMaxLength = 50;

  recycledWaterPlumberPhoneNumberControlMaxLength = 10;
  recycledWaterPlumberPhoneNumberControlMinLength = 10;
  recycledWaterPlumberLicenseNumberControlMaxLength = 6;

  constructor() {
    this.plumberDetails = new PlumberDetails();

    this.drainerNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.drainerNameControlMaxLength)
    ])]);

    this.drainerPhoneNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.drainerPhoneNumberControlMaxLength),
      Validators.minLength(this.drainerPhoneNumberControlMinLength),
      Validators.pattern(numberRE)
    ])]);

    this.drainerLicenseNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.drainerLicenseNumberMaxLength)
    ])]);

    this.drinkingWaterPlumberNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.drinkingWaterPlumberNameControlMaxLength)
    ])]);

    this.drinkingWaterPlumberCompanyControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.drinkingWaterPlumberCompanyControlMaxLength)
    ])]);

    this.drinkingWaterPlumberPhoneNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.drinkingWaterPlumberPhoneNumberControlMaxLength),
      Validators.minLength(this.drinkingWaterPlumberPhoneNumberControlMinLength),
      Validators.pattern(numberRE)
    ])]);

    this.drinkingWaterPlumberLicenseNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.drinkingWaterPlumberLicenseNumberControlMaxLength)
    ])]);

    this.recycledWaterPlumberNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.recycledWaterPlumberNameControlMaxLength)
    ])]);

    this.recycledWaterPlumberPhoneNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.recycledWaterPlumberPhoneNumberControlMaxLength),
      Validators.minLength(this.recycledWaterPlumberPhoneNumberControlMinLength),
      Validators.pattern(numberRE),
      Validators.required
    ])]);

    this.recycledWaterPlumberLicenseNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.recycledWaterPlumberLicenseNumberControlMaxLength)
    ])]);
  }

  ngOnInit() {
  }

  sameAsAboveRecycledWater(): void {
    if (this.isDrinkingWaterSelected) {
      this.plumberDetails.recycledWaterPlumberName = this.plumberDetails.drinkingWaterPlumberName;
      this.plumberDetails.recycledWaterPlumberPhoneNumber = this.plumberDetails.drinkingWaterPlumberPhoneNumber;
      this.plumberDetails.recycledWaterPlumberLicenseNumber = this.plumberDetails.drinkingWaterPlumberLicenseNumber;
    } else if (this.isBelowGroundPlumbingSelected) {
      this.plumberDetails.recycledWaterPlumberName = this.plumberDetails.drainerName;
      this.plumberDetails.recycledWaterPlumberPhoneNumber = this.plumberDetails.drainerPhoneNumber;
      this.plumberDetails.recycledWaterPlumberLicenseNumber = this.plumberDetails.drainerLicenseNumber;
    }
  }

  sameAsAboveDrinkingWater(): void {
    if (this.isBelowGroundPlumbingSelected) {

      this.plumberDetails.drinkingWaterPlumberName = this.plumberDetails.drainerName;
      this.plumberDetails.drinkingWaterPlumberPhoneNumber = this.plumberDetails.drainerPhoneNumber;
      this.plumberDetails.drinkingWaterPlumberLicenseNumber = this.plumberDetails.drainerLicenseNumber;
    }
  }

  get invalid(): boolean {
    return ((this.isBelowGroundPlumbingSelected && this.isBelowGroundPlumbingMandatory
      && (this.drainerNameControl.invalid || this.drainerPhoneNumberControl.invalid
        || this.drainerLicenseNumberControl.invalid))
      || (this.isDrinkingWaterSelected && this.isDrinkingWaterMandatory && (this.drinkingWaterPlumberNameControl.invalid
        || this.drinkingWaterPlumberPhoneNumberControl.invalid
        || this.drinkingWaterPlumberLicenseNumberControl.invalid))
      || (this.isRecycledSelected && this.isRecycledWaterMandatory && this.isRecycledWaterZone
        && (this.recycledWaterPlumberNameControl.invalid
          || this.recycledWaterPlumberPhoneNumberControl.invalid || this.recycledWaterPlumberLicenseNumberControl.invalid)));
  }

  get errorMessage(): string {
    return this.plumberDetails.errorMessage;
  }

  set errorMessage(v: string) {
    this.plumberDetails.errorMessage = v;
  }

  displayErrorMessage(): string {
    this.drainerNameControl.markAsTouched();
    this.drainerPhoneNumberControl.markAsTouched();
    this.drainerLicenseNumberControl.markAsTouched();
    this.drinkingWaterPlumberNameControl.markAsTouched();
    this.drinkingWaterPlumberCompanyControl.markAsTouched();
    this.drinkingWaterPlumberPhoneNumberControl.markAsTouched();
    this.drinkingWaterPlumberLicenseNumberControl.markAsTouched();
    this.recycledWaterPlumberNameControl.markAsTouched();
    this.recycledWaterPlumberLicenseNumberControl.markAsTouched();
    this.recycledWaterPlumberPhoneNumberControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';

    if (this.isBelowGroundPlumbingSelected) {
      if (this.drainerNameControl.invalid) {
        if (this.drainerNameControl.hasError('maxlength')) {
          errorText += this.drainerNameLabel + '\'s Name cannot exceed ' +
            this.drainerNameControlMaxLength + ' characters' + '<br>';
        }

        if (this.isBelowGroundPlumbingMandatory && this.drainerNameControl.hasError('required')) {
          errorText += 'Please enter ' + this.drainerNameLabel + '\'s Name' + '<br>';
        }
      }

      if (this.drainerPhoneNumberControl.invalid) {
        if (this.drainerPhoneNumberControl.hasError('pattern')) {
          errorText += 'Please enter numbers only in ' + this.drainerNameLabel + '\'s Mobile Number' + '<br>';
        } else if (this.drainerPhoneNumberControl.hasError('maxlength') || this.drainerPhoneNumberControl.hasError('minlength')) {
          errorText += this.drainerNameLabel + '\'s Mobile Number should be ' +
            this.drainerPhoneNumberControlMaxLength + ' characters' + '<br>';
        } else if (this.isBelowGroundPlumbingMandatory && this.drainerPhoneNumberControl.hasError('required')) {
          errorText += 'Please enter ' + this.drainerNameLabel + '\'s Mobile Number' + '<br>';
        }
      }

      if (this.drainerLicenseNumberControl.invalid) {
        if (this.drainerPhoneNumberControl.hasError('maxlength')) {
          errorText += this.drainerNameLabel + '\'s License Number cannot exceed '
            + this.drainerLicenseNumberMaxLength + ' characters' + '<br>';
        }

        if (this.isBelowGroundPlumbingMandatory && this.drainerLicenseNumberControl.hasError('required')) {
          errorText += 'Please enter ' + this.drainerNameLabel + '\'s License Number' + '<br>';
        }
      }
    }

    if (this.isDrinkingWaterSelected) {
      if (this.drinkingWaterPlumberNameControl.invalid) {
        if (this.drinkingWaterPlumberNameControl.hasError('maxlength')) {
          errorText += this.drinkingWaterPlumberNameLabel + ' Name cannot exceed ' +
            this.drinkingWaterPlumberNameControlMaxLength + ' characters' + '<br>';
        }
        if (this.isDrinkingWaterMandatory && this.drinkingWaterPlumberNameControl.hasError('required')) {
          errorText += 'Please enter ' + this.drinkingWaterPlumberNameLabel + ' Name' + '<br>';
        }
      }

      if (this.drinkingWaterPlumberCompanyControl.invalid) {
        if (this.drinkingWaterPlumberCompanyControl.hasError('maxlength')) {
          errorText += this.drinkingWaterPlumberNameLabel + ' Company Name cannot exceed ' +
            this.drinkingWaterPlumberCompanyControlMaxLength + ' characters' + '<br>';
        }
      }
      if (this.drinkingWaterPlumberPhoneNumberControl.invalid) {
        if (this.drinkingWaterPlumberPhoneNumberControl.hasError('pattern')) {
          errorText += 'Please enter numbers only in ' + this.drinkingWaterPlumberNameLabel + '\'s Mobile Number' + '<br>';
        } else if (this.drinkingWaterPlumberPhoneNumberControl.hasError('maxlength') ||
          this.drinkingWaterPlumberPhoneNumberControl.hasError('minlength')) {
          errorText += this.drinkingWaterPlumberNameLabel + '\'s Mobile Number should be ' +
            this.drinkingWaterPlumberPhoneNumberControlMaxLength + ' characters' + '<br>';
        } else if (this.isDrinkingWaterMandatory && this.drinkingWaterPlumberPhoneNumberControl.hasError('required')) {
          errorText += 'Please enter ' + this.drinkingWaterPlumberNameLabel + '\'s Mobile Number' + '<br>';
        }
      }

      if (this.drinkingWaterPlumberLicenseNumberControl.invalid) {
        if (this.drinkingWaterPlumberLicenseNumberControl.hasError('maxlength')) {
          errorText += this.drinkingWaterPlumberNameLabel + '\'s License Number cannot exceed ' +
            this.drinkingWaterPlumberLicenseNumberControlMaxLength + ' characters' + '<br>';
        }

        if (this.isDrinkingWaterMandatory && this.drinkingWaterPlumberLicenseNumberControl.hasError('required')) {
          errorText += 'Please enter ' + this.drinkingWaterPlumberNameLabel + '\'s License Number' + '<br>';
        }
      }
    }

    if (this.isRecycledSelected && this.isRecycledWaterZone) {
      if (this.recycledWaterPlumberNameControl.invalid) {
        if (this.recycledWaterPlumberNameControl.hasError('maxlength')) {
          errorText += 'Recycled water Plumber Name cannot exceed ' +
            this.recycledWaterPlumberNameControlMaxLength + ' characters' + '<br>';
        }
        if (this.isRecycledWaterMandatory && this.recycledWaterPlumberNameControl.hasError('required')) {
          errorText += 'Please enter Recycled water Plumber Name' + '<br>';
        }
      }

      if (this.recycledWaterPlumberPhoneNumberControl.invalid) {
        if (this.recycledWaterPlumberPhoneNumberControl.hasError('pattern')) {
          errorText += 'Please enter numbers only in Recycled water Plumber\'s Mobile Number' + '<br>';
        } else if (this.recycledWaterPlumberPhoneNumberControl.hasError('maxlength') ||
          this.recycledWaterPlumberPhoneNumberControl.hasError('minlength')) {
          errorText += 'Recycled water Plumber\'s Mobile Number should be ' +
            this.recycledWaterPlumberPhoneNumberControlMaxLength + ' characters' + '<br>';
        } else if (this.isRecycledWaterMandatory && this.recycledWaterPlumberPhoneNumberControl.hasError('required')) {
          errorText += 'Please enter Recycled water Plumber\'s Mobile Number' + '<br>';
        }
      }

      if (this.recycledWaterPlumberLicenseNumberControl.invalid) {
        if (this.recycledWaterPlumberLicenseNumberControl.hasError('maxlength')) {
          errorText += 'Recycled water Plumber\'s License Number cannot exceed '
            + this.recycledWaterPlumberLicenseNumberControlMaxLength + ' characters' + '<br>';
        }

        if (this.isRecycledWaterMandatory && this.recycledWaterPlumberLicenseNumberControl.hasError('required')) {
          errorText += 'Please enter Recycled water Plumber\'s License Number' + '<br>';
        }
      }
    }

    this.markValidationControlsAsUntouched();

    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    this.drainerNameControl.markAsUntouched();
    this.drainerPhoneNumberControl.markAsUntouched();
    this.drainerLicenseNumberControl.markAsUntouched();
    this.drinkingWaterPlumberNameControl.markAsUntouched();
    this.drinkingWaterPlumberCompanyControl.markAsUntouched();
    this.drinkingWaterPlumberPhoneNumberControl.markAsUntouched();
    this.drinkingWaterPlumberLicenseNumberControl.markAsUntouched();
    this.recycledWaterPlumberNameControl.markAsUntouched();
    this.recycledWaterPlumberLicenseNumberControl.markAsUntouched();
    this.recycledWaterPlumberPhoneNumberControl.markAsUntouched();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/plumber-details/plumber-details.component.ts